import type {
	KorrekturStep,
	StudentKlausurDetailedDTO,
} from "@/lib/orgaAdmin/orgaAdmin.types";

// TODO: This should be a hook, use this also when validating single step assignments

/**
 * Returns a list of step numbers in the klausur (excluding the target step)
 * where the given korrektor is already assigned.
 */
export function findDuplicateKorrektorStepNumbers(
	klausur: StudentKlausurDetailedDTO,
	targetStepNr: number,
	korrektorId: string,
): number[] {
	if (!korrektorId || korrektorId === "remove") return [];
	const duplicates: number[] = [];
	for (const step of klausur.korrekturSteps) {
		if (step.stepNr === targetStepNr) continue;
		if (!step.korrektorId) continue;
		if (step.korrektorId === korrektorId) {
			duplicates.push(step.stepNr);
		}
	}
	return duplicates;
}

/**
 * Checks whether assigning the korrektor to the given step would result in a duplicate
 * within the same klausur (i.e., korrektor already assigned to another step).
 */
export function hasDuplicateKorrektorInKlausur(
	klausur: StudentKlausurDetailedDTO,
	targetStepNr: number,
	korrektorId: string,
): boolean {
	return (
		findDuplicateKorrektorStepNumbers(klausur, targetStepNr, korrektorId)
			.length > 0
	);
}

/**
 * Helper to locate a step by its number from a klausur.
 */
export function getStepByNumber(
	klausur: StudentKlausurDetailedDTO,
	stepNr: number,
): KorrekturStep | undefined {
	return klausur.korrekturSteps.find((s) => s.stepNr === stepNr);
}
